(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saltique-gruns-header"]) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.sqg-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus()})});document.addEventListener('click',event=>{document.querySelectorAll('.sqg-menu[open]').forEach(menu=>{if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saltique-gruns-offers"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('saltique-offer'))customElements.define('saltique-offer',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.syncPurchase();
  this.addEventListener('change',event=>{
   if(event.target.matches('input[name="id"]')){
    this.syncPurchase();
    document.dispatchEvent(new CustomEvent('saltique:variant_selected',{detail:{product:this.dataset.product,variant:event.target.value}}));
    const error=this.querySelector('[data-sq-error]');if(error)error.style.display='none';
    if(document.querySelector('[data-template^="product"]')){const url=new URL(location.href);url.searchParams.set('variant',event.target.value);url.searchParams.delete('selling_plan');history.replaceState(null,'',url)}
   }
   if(event.target.matches('[name="selling_plan"],[name="quantity"]'))this.updateTotal();
  });
  this.addEventListener('input',event=>{if(event.target.matches('[name="quantity"]'))this.updateTotal()});
  this.addEventListener('click',event=>{
   const step=event.target.closest('[data-step]');if(step){const input=this.querySelector('[name="quantity"]');input.value=Math.max(1,Math.min(99,(Number(input.value)||1)+Number(step.dataset.step)));this.updateTotal()}
   const thumb=event.target.closest('[data-image]');if(thumb){const image=this.querySelector('.sqg-main-image');if(image){image.removeAttribute('srcset');image.src=thumb.dataset.image;image.alt=thumb.dataset.alt;this.querySelectorAll('[data-image]').forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)))}}
  });
 }
 syncPurchase(){
  const variant=this.querySelector('input[name="id"]:checked');if(!variant)return;
  this.querySelectorAll('[data-purchase-variant]').forEach(group=>{const active=group.dataset.purchaseVariant===variant.value;group.hidden=!active;group.disabled=!active;if(active){const once=group.querySelector('[name="selling_plan"][value=""]');const input=once||group.querySelector('[name="selling_plan"]');if(input)input.checked=true}});
  this.updateTotal();
 }
 updateTotal(){
  const group=this.querySelector('[data-purchase-variant]:not([hidden])');const plan=group?.querySelector('[name="selling_plan"]:checked');const input=this.querySelector('[name="quantity"]');const quantity=Number(input.value);
  if(!plan)return;
  group.querySelectorAll('[data-plan-terms]').forEach(el=>el.hidden=el.dataset.planTerms!==plan.value);
  const amount=Number(plan.dataset.charge)*(Number.isFinite(quantity)&&quantity>0?quantity:1);
  this.querySelector('.sqg-live-price').textContent=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency,currencyDisplay:'code'}).format(amount/100);
  sqgUpdateSticky();
 }
});
function sqgActivateTab(tab){const section=tab.closest('.sqg-offers');section.querySelectorAll('[role="tab"]').forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active});sqgUpdateSticky()}
document.addEventListener('click',event=>{const tab=event.target.closest('.sqg-offer-tabs [role="tab"]');if(tab)sqgActivateTab(tab);const choice=event.target.closest('[data-sqg-product]');if(choice){const offer=Array.from(document.querySelectorAll('saltique-offer')).find(p=>p.dataset.product===choice.dataset.sqgProduct);const panel=offer?.closest('[role=tabpanel]');if(panel){sqgActivateTab(document.getElementById(panel.getAttribute('aria-labelledby')));document.dispatchEvent(new CustomEvent('saltique:product_selected',{detail:{product:choice.dataset.sqgProduct}}))}}});document.addEventListener('keydown',event=>{const tab=event.target.closest('.sqg-offer-tabs [role="tab"]');if(!tab)return;const tabs=Array.from(tab.parentElement.querySelectorAll('[role="tab"]'));let index=tabs.indexOf(tab);if(event.key==='ArrowRight')index=(index+1)%tabs.length;else if(event.key==='ArrowLeft')index=(index-1+tabs.length)%tabs.length;else if(event.key==='Home')index=0;else if(event.key==='End')index=tabs.length-1;else return;event.preventDefault();sqgActivateTab(tabs[index]);tabs[index].focus()});
function sqgUpdateSticky(){const bar=document.querySelector('[data-sqg-sticky]');if(!bar)return;const offer=Array.from(document.querySelectorAll('saltique-offer')).find(p=>!p.closest('[hidden]'));if(!offer)return;const buy=offer.querySelector('.sqg-buy-row');bar.querySelector('[data-sqg-sticky-title]').textContent=offer.dataset.title;bar.querySelector('[data-sqg-sticky-price]').textContent=offer.querySelector('.sqg-live-price').textContent;bar.hidden=buy.getBoundingClientRect().bottom>0;document.body.style.paddingBottom=bar.hidden?'':bar.offsetHeight+'px'}
window.addEventListener('scroll',sqgUpdateSticky,{passive:true});window.addEventListener('resize',sqgUpdateSticky);sqgUpdateSticky();

  } catch(e) { console.error(e); }
})();
})();
